var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
export class Testimonials extends Component {
    constructor() {
        super('Testimonials', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            if ($('.module-testimonials').length > 0) {
                $(window).on('resize', () => {
                    this.computeNavPosition();
                    this.computeTestimonialHeight();
                });
                this.computeNavPosition();
                this.computeTestimonialHeight();
                setTimeout(() => {
                    this.computeNavPosition();
                    this.computeTestimonialHeight();
                }, 1000);
            }
            this.success();
        });
    }
    computeNavPosition() {
        $('.module-testimonials').each((module) => {
            let captionTop = 0;
            let captionLeft = 0;
            module.find('.carousel-item').addClass('active').each((carouselItem) => {
                var _a, _b, _c;
                const caption = carouselItem.find('.module-testimonials--author');
                console.log(caption.position(carouselItem).y);
                if (caption.length > 0) {
                    const currentCaptionTop = ((_a = caption.position(carouselItem).y) !== null && _a !== void 0 ? _a : 0) + ((_b = caption.height()) !== null && _b !== void 0 ? _b : 0) + 12;
                    const currentCaptionLeft = (_c = caption.position(carouselItem).x) !== null && _c !== void 0 ? _c : 0;
                    if (currentCaptionTop > captionTop)
                        captionTop = currentCaptionTop;
                    if (currentCaptionLeft > captionLeft)
                        captionLeft = currentCaptionLeft;
                }
            });
            module.find('.btn-prev, .btn-next').css({
                top: `${captionTop}px`,
            });
            module.find('.btn-prev').css({
                left: `${captionLeft}px`
            });
            module.find('.btn-next').css({
                left: `${captionLeft + ($(window).width() < 768 ? 32 : 46)}px`
            });
            module.find('.carousel-item:not(:first-child)').removeClass('active');
        });
    }
    computeTestimonialHeight() {
        if ($(window).width() >= 992)
            return;
        $('.module-testimonials').each((module) => {
            let maxHeight = 0;
            module.find('.carousel-item').addClass('active').each((carouselItem) => {
                var _a;
                const currentHeight = (_a = carouselItem.height()) !== null && _a !== void 0 ? _a : 0;
                if (currentHeight > maxHeight)
                    maxHeight = currentHeight;
            });
            module.find('.carousel-item').css({
                height: `${maxHeight}px`
            });
            module.find('.carousel-item:not(:first-child)').removeClass('active');
        });
    }
}
